"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterGamesByTitle = void 0;
var filterGamesByTitle = function (games, title) {
    if (title) {
        return games.filter(function (game) { var _a; return (_a = game.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(title.toLowerCase()); });
    }
    return games;
};
exports.filterGamesByTitle = filterGamesByTitle;
